// Core
//
import { Controller } from 'stimulus';

// Helpers
//
import { addClass, removeClass, hasClass } from '../../../dom-helper';

// Plugins
//
import axios, { AxiosResponse } from 'axios';

// Components
//
import PubSub from 'pubsub-js';
import selectionStore from '../../item_selection_store';

export default class extends Controller {
  static targets = ['bulkEditAction', 'bulkEditProjectAction', 'newTaskAction', 'bulkEditShopActionTarget', 'bulkEditUnlistActionTarget', 'bulkReSyncAction'];

  bulkEditActionTarget: any;
  bulkEditProjectActionTarget: any;
  newTaskActionTarget: any;
  bulkEditShopActionTarget: any;
  bulkEditUnlistActionTarget: any;
  bulkReSyncActionTarget: any;

  window: any = window;

  topic: string = 'item.selector';
  token: any;

  connect() {
    this.updateUI(selectionStore.count());

    this.token = PubSub.subscribe(this.topic, () => {
      this.updateUI(selectionStore.count());
    });
  }

  updateUI(count: number) {
    document.querySelectorAll('.item-selector--counter').forEach((el: any) => {
      el.innerHTML = String(count);
    });

    if (count > 0) {
      removeClass(this.bulkEditActionTarget, '-color-gray_dark');
      this.bulkEditActionTarget.setAttribute('title', '');
      this.bulkEditActionTarget.setAttribute('data-original-title', '');

      removeClass(this.bulkEditProjectActionTarget, '-color-gray_dark');
      this.bulkEditProjectActionTarget.setAttribute('title', '');
      this.bulkEditProjectActionTarget.setAttribute('data-original-title', '');

      if (this.newTaskActionTarget) {
        removeClass(this.newTaskActionTarget, '-color-gray_dark');
        this.newTaskActionTarget.setAttribute('title', '');
        this.newTaskActionTarget.setAttribute('data-original-title', '');
      }

      removeClass(this.bulkEditShopActionTarget, '-color-gray_dark');
      this.bulkEditShopActionTarget.setAttribute('title', '');
      this.bulkEditShopActionTarget.setAttribute('data-original-title', '');

      removeClass(this.bulkEditUnlistActionTarget, '-color-gray_dark');
      this.bulkEditUnlistActionTarget.setAttribute('title', '');
      this.bulkEditUnlistActionTarget.setAttribute('data-original-title', '');

      if (this.bulkReSyncActionTarget) {
        removeClass(this.bulkReSyncActionTarget, '-color-gray_dark');
        this.bulkReSyncActionTarget.setAttribute('title', '');
        this.bulkReSyncActionTarget.setAttribute('data-original-title', '');
      }
    } else {
      addClass(this.bulkEditActionTarget, '-color-gray_dark');
      this.bulkEditActionTarget.setAttribute('title', 'You must select at least 1 EFFC&M™ to Bulk Edit');

      addClass(this.bulkEditProjectActionTarget, '-color-gray_dark');
      this.bulkEditProjectActionTarget.setAttribute('title', 'You must select at least 1 EFFC&M™ to Bulk Edit Project');

      if (this.newTaskActionTarget) {
        addClass(this.newTaskActionTarget, '-color-gray_dark');
        this.newTaskActionTarget.setAttribute('title', 'You must select at least 1 EFFC&M™ to create a new PlanME - Work Request');

        addClass(this.bulkEditShopActionTarget, '-color-gray_dark');
        this.bulkEditShopActionTarget.setAttribute('title', 'You must select at least 1 EFFC&M™ to List on ED-iMART™');

        addClass(this.bulkEditUnlistActionTarget, '-color-gray_dark');
        this.bulkEditUnlistActionTarget.setAttribute('title', 'You must select at least 1 EFFC&M™ to Unlist from ED-iMART™');

        if (this.bulkReSyncActionTarget) {
          addClass(this.bulkReSyncActionTarget, '-color-gray_dark');
          this.bulkReSyncActionTarget.setAttribute('title', 'You must select at least 1 EFFC&M™ to Bulk Re-sync');
        }
      }

      addClass(this.bulkEditShopActionTarget, '-color-gray_dark');
      this.bulkEditShopActionTarget.setAttribute('title', 'You must select at least 1 EFFC&M™ to List on ED-iMART™');

      addClass(this.bulkEditUnlistActionTarget, '-color-gray_dark');
      this.bulkEditUnlistActionTarget.setAttribute('title', 'You must select at least 1 EFFC&M™ to Unlist from ED-iMART™');

      if (this.bulkReSyncActionTarget) {
        addClass(this.bulkReSyncActionTarget, '-color-gray_dark');
        this.bulkReSyncActionTarget.setAttribute('title', 'You must select at least 1 EFFC&M™ to Bulk Re-sync');
      }
    }
  }

  bulkEditItems(event: any) {
    event.preventDefault();
    const url: string = this.bulkEditActionTarget.dataset.url;
    const items = selectionStore.getAll();
    selectionStore.clear();
    this.window.location = `${ url }?items=${ items.map((item: any) => item.uuid) }`;
  }

  bulkEditProjectItems(event: any) {
    event.preventDefault();
    const url: string = this.bulkEditProjectActionTarget.dataset.url;
    const items = selectionStore.getAll();
    selectionStore.clear();
    this.window.location = `${ url }?project_only=true&items=${ items.map((item: any) => item.uuid) }`;
  }

  bulkEditShopItems(event: any) {
    event.preventDefault();
    const url: string = this.bulkEditProjectActionTarget.dataset.url;
    const items = selectionStore.getAll();
    selectionStore.clear();
    this.window.location = `${ url }?add_to_shop=true&items=${ items.map((item: any) => item.uuid) }`;
  }

  bulkEditUnlistItems(event: any) {
    event.preventDefault();
    const url: string = this.bulkEditProjectActionTarget.dataset.url;
    const items = selectionStore.getAll();
    selectionStore.clear();
    this.window.location = `${ url }?unliste_from_edimart=true&items=${ items.map((item: any) => item.uuid) }`;
  }

  bulkReSyncItems(event: any) {
    event.preventDefault();
    const url: string = this.bulkEditActionTarget.dataset.url;
    const items = selectionStore.getAll();
    selectionStore.clear();
    this.window.location = `${ url }?bulk_reindex=true&items=${ items.map((item: any) => item.uuid) }`;
  }

  disconnect() {
    PubSub.unsubscribe(this.token);
  }
}
